import EcommerceChangesPeriod from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceChangesPeriod";
import EcommerceChangesTrend from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceChangesTrend";

/** API payload values for ecommerce change direction (single source of truth). */
export const ECOMMERCE_CHANGE_DIRECTION_TO_API = {
    [EcommerceChangesTrend.Grew]: "Grew",
    [EcommerceChangesTrend.Declined]: "Declined",
} as const satisfies Record<EcommerceChangesTrend, "Grew" | "Declined">;

/** API payload values for ecommerce change period (single source of truth). */
export const ECOMMERCE_CHANGE_PERIOD_TO_API = {
    [EcommerceChangesPeriod.MonthOverMonth]: "Mom",
    [EcommerceChangesPeriod.QuoterOverQuoter]: "Qoq",
    [EcommerceChangesPeriod.YearOverYear]: "Yoy",
} as const satisfies Record<EcommerceChangesPeriod, "Mom" | "Qoq" | "Yoy">;
